/**
 * Liste maître des formations « classique » : instruments (y compris baroque / anciens)
 * et effectifs. Utilisée pour autocomplete et filtres (metadata.formation = ids).
 */

export const CLASSICAL_FORMATIONS = [
  // Claviers
  { id: 'piano', label: 'Piano' },
  { id: 'clavecin', label: 'Clavecin' },
  { id: 'orgue', label: 'Orgue' },
  { id: 'celesta', label: 'Célesta' },
  { id: 'clavecin_brise', label: 'Clavecin brisé' },
  { id: 'virginal', label: 'Virginal' },
  { id: 'clavecin_pedalier', label: 'Clavecin à pédalier' },

  // Cordes frottées
  { id: 'violon', label: 'Violon' },
  { id: 'alto', label: 'Alto' },
  { id: 'violoncelle', label: 'Violoncelle' },
  { id: 'contrebasse', label: 'Contrebasse' },
  { id: 'viole_de_gambe', label: 'Viole de gambe' },
  { id: 'violon_baroque', label: 'Violon baroque' },
  { id: 'viole_taille', label: 'Viole taille' },

  // Cordes pincées / guitares
  { id: 'harpe', label: 'Harpe' },
  { id: 'guitare_classique', label: 'Guitare classique' },
  { id: 'theorbe', label: 'Théorbe' },
  { id: 'luth', label: 'Luth' },
  { id: 'mandoline', label: 'Mandoline' },
  { id: 'vielle', label: 'Vielle à roue' },

  // Bois
  { id: 'flute', label: 'Flûte' },
  { id: 'flute_a_bec', label: 'Flûte à bec' },
  { id: 'flute_basse', label: 'Flûte basse' },
  { id: 'piccolo', label: 'Piccolo' },
  { id: 'hautbois', label: 'Hautbois' },
  { id: 'cor_anglais', label: 'Cor anglais' },
  { id: 'clarinette', label: 'Clarinette' },
  { id: 'clarinette_basse', label: 'Clarinette basse' },
  { id: 'basson', label: 'Basson' },
  { id: 'contrebasson', label: 'Contrebasson' },
  { id: 'saxophone', label: 'Saxophone' },

  // Cuivres
  { id: 'cor', label: 'Cor' },
  { id: 'cor_naturel', label: 'Cor naturel (baroque)' },
  { id: 'cornet', label: 'Cornet' },
  { id: 'trompette', label: 'Trompette' },
  { id: 'trombone', label: 'Trombone' },
  { id: 'tuba', label: 'Tuba' },
  { id: 'euphonium', label: 'Euphonium' },

  // Percussions / claviers de percussion
  { id: 'timbales', label: 'Timbales' },
  { id: 'percussion', label: 'Percussion' },
  { id: 'xylophone', label: 'Xylophone' },
  { id: 'marimba', label: 'Marimba' },
  { id: 'vibraphone', label: 'Vibraphone' },
  { id: 'tambourin', label: 'Tambourin' },
  { id: 'caisse_claire', label: 'Caisse claire' },
  { id: 'gong', label: 'Gong' },
  { id: 'carillon', label: 'Carillon' },

  // Voix
  { id: 'chant', label: 'Chant' },

  // Effectifs
  { id: 'musique_de_chambre', label: 'Musique de chambre' },
  { id: 'orchestre_chambre', label: 'Orchestre de chambre' },
  { id: 'orchestre_symphonique', label: 'Orchestre symphonique' },
  { id: 'choeur', label: 'Chœur' },

  { id: 'autre_solo', label: 'Autre instrument soliste' },
  { id: 'autre', label: 'Autre' }
]
